import { getFreeLayoutById } from './getLayout';
import type { AppState } from 'state/model';

export function getItemPositionsByLayoutId(state: AppState, layoutId: string) {
  const layout = getFreeLayoutById(state, layoutId);
  return layout.itemPositions;
}
